import { num } from '../../scene/component-types.js';
import type { SettingsSection } from '../settings-types.js';

/** `settings.time` (prism_core::TimeSettings). Physics steps at the fixed timestep. */
const time: SettingsSection = {
  key: 'time',
  label: 'Time',
  icon: 'refresh',
  order: 31,
  hint: 'Fixed timestep, frame delta limit, time scale',
  fields: [
    {
      key: 'fixedTimestep',
      label: 'Fixed timestep',
      type: num(0.001, { min: 0.0001, max: 1 }),
      read: () => 1 / 60,
      hint: 'seconds per fixed step (on_fixed_update and physics); 0.0166667 = 60 Hz',
    },
    {
      key: 'maximumDeltaTime',
      label: 'Maximum delta time',
      type: num(0.01, { min: 0.001, max: 10 }),
      read: () => 0.25,
      hint: 'longest frame the game sees; longer hitches slow the game down',
    },
    {
      key: 'maxFixedStepsPerFrame',
      label: 'Max fixed steps / frame',
      type: num(1, { min: 1, max: 64, integer: true }),
      read: () => 8,
      hint: 'most fixed steps in one frame (avoids the spiral of death)',
    },
    {
      key: 'timeScale',
      label: 'Time scale',
      type: num(0.05, { min: 0, max: 100 }),
      read: () => 1,
      hint: 'starting game speed (0 = frozen); scripts: set_time_scale',
    },
  ],
};

export default time;
